import type { Notice, CreateNoticeInput } from '@grosync/common';
import { apiGet, apiPost } from './client';

/** 공지 발송 이력 (최신순). */
export function fetchNotices(): Promise<Notice[]> {
  return apiGet<Notice[]>('/api/notices');
}

/** 공지 발송(또는 예약). 서버가 도달 회원 수(reach)·상태를 계산해 반환. */
export function createNotice(body: CreateNoticeInput): Promise<Notice> {
  return apiPost<Notice>('/api/notices', body);
}
